<script setup>
import { RouterLink, RouterView, useRoute } from "vue-router";
import Header from "@/components/Header.vue";
import { computed } from "vue";

const route = useRoute();

const isLoginPage = computed(() => {
  // get the current path
  const currentPath = route.path;
  // console.log(currentPath,'2222测试头文件')
  //需要配置所有的移动页面都不要显示header
  return ["/", "/login", "/applogin","/patientsApp", "/detailsApp"].includes(currentPath);
});
</script>

<template>
  <Header v-if="!isLoginPage"></Header>
  <div :class="isLoginPage? '':'router-view'">
    <RouterView />
  </div>

</template>

<style scoped>
.router-view {
    padding: 15px;
    overflow: hidden;
}
</style>
